import ListButton from "src/components/ListButton";
import { Flex, Box } from "@chakra-ui/react";
import { ReactComponent as DeleteIcon } from "src/icons/delete-outlined.svg";
import { ReactComponent as LoginIcon } from "./icons/login.svg";
import { ReactComponent as PremiumIcon } from "./icons/premium.svg";
import { ReactComponent as SignOutIcon } from "./icons/logout.svg";
import { ReactComponent as PurchaseIcon } from "./icons/purchase.svg";
import { ReactComponent as ResetIcon } from "./icons/reset.svg";
import { ReactComponent as SignUpIcon } from "./icons/signup.svg";
import { ReactComponent as LoopIcon } from "./icons/loop-small.svg";

export default function Buttons({
  hasPremium,
  canManageSubscription,
  isLoggedIn,
  flow,
  onPurchase,
  onRestore,
  onSignOut,
  onReset,
  openDeleteAccountDialog,
  openPremiumWarningDialog,
  ...rest
}) {
  const buttons = {
    purchase: {
      labelKey: "buttons.upgradeToPremium",
      icon: PremiumIcon,
      iconFill: "tint2",
      onClick: () => flow.push("purchase")
    },
    restore: {
      icon: PurchaseIcon,
      iconFill: "primary",
      labelKey: "buttons.restorePurchase",
      onClick: () => flow.push("restore")
    },
    login: {
      icon: LoginIcon,
      iconFill: "primary",
      labelKey: "buttons.logIn",
      onClick: () => flow.push("login")
    },
    signOut: {
      icon: SignOutIcon,
      iconFill: "primary",
      labelKey: "buttons.logOut",
      onClick: onSignOut
    },
    signUp: {
      icon: SignUpIcon,
      iconFill: "primary",
      labelKey: "buttons.createAccount",
      onClick: () => flow.push("sign-up")
    },
    manageSubscription: {
      icon: LoopIcon,
      iconFill: "primary",
      labelKey: "purchase.manageSubscription",
      onClick: () =>
        canManageSubscription
          ? flow.push("manage-subscription")
          : openPremiumWarningDialog()
    },
    reset: {
      icon: ResetIcon,
      iconFill: "primary",
      labelKey: "buttons.reset",
      onClick: onReset
    },
    deleteAccount: {
      icon: DeleteIcon,
      iconFill: "primary",
      labelKey: "buttons.deleteAccount",
      onClick: openDeleteAccountDialog
    }
  };

  const buttonsList = [];
  if (hasPremium) {
    buttonsList.push(buttons.signOut);
    buttonsList.push(buttons.manageSubscription);
  }
  if (!hasPremium) {
    buttonsList.push(buttons.purchase);
    buttonsList.push(isLoggedIn ? buttons.signOut : buttons.login);
    if (!isLoggedIn) buttonsList.push(buttons.signUp);
  }
  if (!isLoggedIn) buttonsList.push(buttons.reset);
  if (isLoggedIn) buttonsList.push(buttons.deleteAccount);

  return (
    <Flex flexWrap="wrap" {...rest} mr="-24px">
      {buttonsList.map((button) => (
        <Box key={button.labelKey} width="50%" pr="24px" mb="16px">
          <ListButton {...button} />
        </Box>
      ))}
    </Flex>
  );
}
